import * as React from 'react';
import { useTranslation } from '@lib/useTypedTranslation';
import { ChipButton } from './chipButton';

import './bearerTypePicker.css';

const bearerTypes: (string | null)[] = [null, '2g', '3g', '4g', '5g'];

type BearerTypePickerProps = {
  selectedBearer: string | null,
  onChange: (bearerType: string | null) => void
};

export const BearerTypePicker: React.FC<BearerTypePickerProps> = ({ selectedBearer, onChange }) => {
  const { t } = useTranslation('translation');

  return <div className="bearer-type-picker">
    {bearerTypes.map(bearerType => (
      <ChipButton
        key={bearerType || 'All'}
        text={bearerType?.toUpperCase() || t('ALL')}
        active={bearerType === selectedBearer}
        onClick={() => {
          if (bearerType !== selectedBearer) {
            onChange(bearerType);
          }
        }}
      />
    ))}
  </div>;
};
